/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useState } from 'react';
import { KTSVG } from '../../../../../../_metronic/helpers';
import { useToast } from '../../../Toats';
import { useQuery } from 'react-query';
import { deleteArchiveOne, getArchivesPlant, getArchivesPlantOne, postArchivePlantOne } from '../../../../../services/archivesService';
import { generateHexSequence } from '../../../../../utils/generateNumberHex';
import { Loading } from '../../../Loadings/loading';
import { useAuth } from '../../../../../modules/auth';
import { ModalDeleteArquivos } from '../../../modalPlant/components/ArchivesPlant/Components/ModalDeleteArquives';

export function ArchivesPlant({data}: any) {
    const [loadingPost, setLoadingPost] = useState<boolean>(false);
    const [loadingDelete, setLoadingDelete] = useState<boolean>(false);
    const [loadingOpenArchive, setLoadingOpenArchive] = useState<boolean>(false);
    const { toggleToast } = useToast();
    const [textArquive] = useState<string>("Escolha um arquivo.");
    const [idArquiveOpen, setIdArquiveOpen] = useState<string | null>(null);
    const fileInputRef : any = useRef(null);
    const { currentUser } = useAuth();
    const [showModalDeleteArquivos, setShowModalDeleteArquivos] = useState<boolean>(false);

    const handleButtonClick = () => {
      fileInputRef.current.click();
    };

    const { data: archives = [], isLoading: loading, refetch } = useQuery(
        ["getMyArchives"],
        async () => {
            const archives = await getArchivesPlant(data && data.id ? data.id : "");
            console.log(archives)
            return archives;
        },
        {
          onError: (error) => {
            console.log(error);
          },
        }
    )

    const deleteArchive = async (id: string) => {
        try {
          setIdArquiveOpen(id)
          setShowModalDeleteArquivos(true)
        } catch (error) {
          console.log(error)
        }
    }


    const postArchivePlant = async (file: File | undefined) => {
        try {
            setLoadingPost(true)
            const formData = new FormData();
            if(file){
                const originalName = file.name;
                //const extension = originalName.split('.').pop()?.toLowerCase() || 'unknown';
                const key = `${generateHexSequence(10)}-${originalName}`;
            
                const description = `${originalName}`;
    
                formData.append("file", file);
                formData.append('key', key);
                formData.append('description', description);
                formData.append('idPlant', data && data.id ? data.id : "");
                
                await postArchivePlantOne(formData)
                toggleToast("Sucesso ao cadastrar o template. ", "success")
            }
        } catch (error) {
            toggleToast("Erro ao cadastrar template. ", "error")
        }finally{
            setLoadingPost(false)
            refetch()
        }
    }

    const getArchivePlant = async (idArchive: string) => {
        try {
            setLoadingOpenArchive(true)
            const myArchive = await getArchivesPlantOne(idArchive);
            if(myArchive && myArchive.url){
                window.open(myArchive.url, '_blank', 'noopener,noreferrer');
            }     
        } catch (error) {
          console.log(error)
        }finally{
            setIdArquiveOpen(null)
            setLoadingOpenArchive(false)
        }
    }

    const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        await postArchivePlant(file)
    };

  return (
    <div className='d-flex flex-column flex-grow-1' style={{height: '35rem'}}>
        <div
            className='card border border-gray-300 border-dashed rounded py-3 px-4 d-flex flex-wrap'
            style={{flexDirection: 'column', width: '100%', height: '100%'}}  
        >
            <div style={{height: '100%'}}>
                <div className='border border-gray-200 border-dashed rounded p-1'>
                    <div className="d-flex align-items-center justify-content-center" style={{width: '100%', height: '6rem'}}>
                        <input
                            type="file"
                            ref={fileInputRef}
                            onChange={handleUpload}
                            style={{ display: 'none' }}
                        />

                        <button
                            onClick={() =>{handleButtonClick()}}
                            style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}
                            className='btn btn-sm btn-light-primary text-hover-white'
                        >
                        {loadingPost ? 
                            <Loading myClass='spinner-border' style={{width: '1rem', height: '1rem'}}/> :
                            <KTSVG path='/media/icons/duotune/files/fil009.svg' className='svg-icon-2x' />
                        }
                        
                        <h3 className='card-title align-items-start flex-column'>
                            {/* <span className='card-label fw-bold fs-3 mb-1'>Adicionar Cliente (Planilha)</span> */}
                            <span className='mt-1 fw-semibold fs-7'>{textArquive}</span>
                        </h3>
                        </button>
                    </div>
                </div>
                <div 
                    className='card border border-gray-300 border-dashed rounded p-4 mt-2' 
                    style={{height: '77%', overflow: 'auto'}}
                >
                    {archives.length <= 0 && (
                        <div className='bg-light' 
                            style={{
                                width: '100%', 
                                height: '100%', 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center',
                                gap: '0.5rem',
                                flexDirection: 'column'
                            }}
                        >
                            <KTSVG
                                path="/media/icons/duotune/general/gen004.svg"
                                className='svg-icon-3x me-1'
                            />
                            <h3 className='card-title d-flex align-items-center justify-content-center flex-column'>
                            <span className='text-muted fw-semibold fs-7'>Sem anexos!</span>
                            </h3>
                        </div>
                    )}

                    {archives.length > 0 && 
                        archives.map((archive: any) => {
                            return (
                                <div className='d-flex' style={{alignItems: 'center', gap: '0.5rem'}}>
                                    <div className='symbol symbol-40px symbol-circle'>
                                        <div className='symbol symbol-40px symbol-circle'>
                                            <span className={`symbol-label bg-light-primary text-primary fs-9 fw-bolder`}>
                                            {archive && archive.description ? (
                                                (() => {
                                                    const ext = archive.description.split('.').pop().toLowerCase();
                                                    const iconMap = {
                                                    jpg: 'bi-filetype-jpg',
                                                    jpeg: 'bi-filetype-jpg',
                                                    png: 'bi-filetype-png',
                                                    pdf: 'bi-filetype-pdf',
                                                    doc: 'bi-filetype-doc',
                                                    docx: 'bi-filetype-doc',
                                                    xls: 'bi-filetype-xls',
                                                    xlsx: 'bi-filetype-xls',
                                                    ppt: 'bi-filetype-ppt',
                                                    pptx: 'bi-filetype-ppt',
                                                    txt: 'bi-filetype-txt',
                                                    zip: 'bi-file-earmark-zip',
                                                    default: 'bi-file-earmark'
                                                    };
                                                    const iconClass = iconMap[ext] || iconMap.default;
                                                    return <i className={`bi ${iconClass} fs-1`}></i>;
                                                })()
                                                ) : null
                                            }
                                            </span>
                                        </div>
                                    </div>
                                    <div className='' style={{width: '100%'}}>
                                        <div className='d-flex justify-content-start flex-column bg-light p-2'>
                                            <a 
                                                href="#" 
                                                className='' 
                                                onClick={() => {
                                                    getArchivePlant(archive.id);
                                                    setIdArquiveOpen(archive.id)
                                                }}
                                            >
                                                <span className='text-muted fw-semibold text-hover-primary d-block fs-7'>
                                                    {archive && archive.description ? archive.description : "Nao encontrado"}
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    <div>
                                        {loadingOpenArchive && idArquiveOpen === archive.id ?
                                            <Loading myClass='spinner-border' style={{width: '1rem', height: '1rem'}}/>
                                        :
                                            currentUser?.role.slug !== "CLIENTE" && 
                                            <button
                                                onClick={(event: any) => {
                                                    deleteArchive(archive.id)
                                                }}
                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                            >
                                                <KTSVG
                                                    path='/media/icons/duotune/general/gen027.svg'
                                                    className='svg-icon-3'
                                                />
                                            </button>
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                
            </div>
        </div>

        <ModalDeleteArquivos
            show={showModalDeleteArquivos}
            handleClose={() => {
                setShowModalDeleteArquivos(false)
                refetch()
            }}
            id={idArquiveOpen && idArquiveOpen !== null ? idArquiveOpen : ""}
            data={archives.find((archive: any) => archive.id === idArquiveOpen)}
        />
    </div>
  );
}